import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User created a person',
  name: 'person_created',
  params: [
    {
      description: 'Person ID',
      name: 'person_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Name',
      name: 'name',
      required: true,
      type: 'string',
    },
    {
      description: 'Location of event',
      name: 'location',
      required: true,
      type: 'enum',
      values: [
        'image-preview',
        'people-tab',
        'unnamed-people-page',
        'named-people-page',
        'people-settings',
        'person-page-header',
        'person-page-menu',
      ],
    },
  ],
};

export default META;
